// extracted by mini-css-extract-plugin
module.exports = {"root":"ResponsiveColumn_root__TK1iJ","spinAround":"ResponsiveColumn_spinAround__6V35q"};